module.exports = __webpack_public_path__ + "static/media/Luettelo-thumbnail.40eae353.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/screenCaptures/Luettelo-thumbnail.png
// module id = 1428
// module chunks = 0